/** Temporary portal gate — replace with real auth before production launch. */
export const PARTNER_PORTAL_EMAIL =
  process.env.REACT_APP_PARTNER_DEMO_EMAIL ?? 'demo@chisme.social';

export const PARTNER_PORTAL_PASSWORD =
  process.env.REACT_APP_PARTNER_DEMO_PASSWORD ?? 'ChismeDemo2026';

export const PARTNER_PORTAL_NAME =
  process.env.REACT_APP_PARTNER_DEMO_NAME ?? 'Demo Partner';

export function isValidPortalLogin(email: string, password: string): boolean {
  const normalizedEmail = email.trim().toLowerCase();
  const expectedEmail = PARTNER_PORTAL_EMAIL.trim().toLowerCase();
  return normalizedEmail === expectedEmail && password === PARTNER_PORTAL_PASSWORD;
}
